const LocationName = ({ name }) => {
  if (!name) { return null }

  return (
    <span className="location-element-scope-name badge badge-light">[{name}]</span>
  )
}

export default LocationName
